import React, { useEffect, useMemo } from 'react';
import BmbHero from '../components/mk/bmb/BmbHero';
import BmbHow from '../components/mk/bmb/BmbHow';
import BmbPauses from '../components/mk/bmb/BmbPauses';
import BmbSites from '../components/mk/bmb/BmbSites';
import BmbPatterns from '../components/mk/bmb/BmbPatterns';
import BmbHardBlock from '../components/mk/bmb/BmbHardBlock';
import BmbSetup from '../components/mk/bmb/BmbSetup';
import BmbPlans from '../components/mk/bmb/BmbPlans';
import BmbPairKmo from '../components/mk/bmb/BmbPairKmo';
import BmbFaq from '../components/mk/bmb/BmbFaq';
import BmbFinal from '../components/mk/bmb/BmbFinal';
import MkFounderNote from '../components/mk/MkFounderNote';
import MkStickyCta from '../components/mk/MkStickyCta';
import { detectPlatform } from '../marketing/links';
import { mkTrack } from '../marketing/track';

// keepmeout.app/bring-me-back — room for honest detail about the companion app.
// No Bring Me Back downloads, ratings, reviews or user counts anywhere on this page.
const BringMeBack = ({ platform: forced }) => {
  const platform = useMemo(() => forced || detectPlatform(), [forced]);
  useEffect(() => {
    mkTrack('platform_view', `${platform}:bmb`, { nonInteraction: true });
  }, [platform]);
  return (
    <>
      <div className="mk-page mk-bmb">
        <BmbHero platform={platform} />
        <BmbHow />
        <BmbPauses />
        <BmbSites />
        <BmbPatterns />
        <BmbHardBlock />
        <BmbSetup platform={platform} />
        <BmbPlans />
        <section className="mk-bmbnote section" id="why" aria-labelledby="mk-founder-compact-title">
          <div className="container-sm">
            <div className="section-inner">
              <MkFounderNote variant="compact" platform={platform} placement="bmb" />
            </div>
          </div>
        </section>
        <BmbPairKmo platform={platform} />
        <BmbFaq />
        <BmbFinal platform={platform} />
      </div>
      <MkStickyCta app="bmb" platform={platform} page="bmb" />
    </>
  );
};

export default BringMeBack;
